import * as React from 'react';

import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
const ButtonGradient = styled(({ ...other }) => <Button {...other} />)(
  ({ theme }) => ({
    '&.MuiButton-contained': {
      background: theme.palette.gradient.main,
      color: theme.palette.gradient.textContract,
      '&:hover': {
        background: theme.palette.gradient.hover,
      },
    },
    // '&.MuiButton-outlined': {
    //   background: 'black',
    //   backgroundClip: 'padding-box',

    //   position: 'relative',
    //   border: '5px solid ',
    //   borderColor: 'transparent',
    //   '&:before': {
    //     content: '""',
    //     position: 'absolute',
    //     top: 0,
    //     right: 0,
    //     bottom: 0,
    //     left: 0,
    //     zIndex: -1,
    //     borderRadius: 'inherit',
    //     margin: -5,
    //     background: theme.palette.gradient.main,
    //   },
    // },
  }),
);

export default ButtonGradient;
